import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useDataProvider } from 'react-admin';
import type { GPDataProvider } from '../index';
import type {
  ReportClickReferrerCreate,
  ReportClickReferrerCreateParams,
} from '../CustomMethods/Report';
import { type ActionHook, type ActionOptions, stableSerialize } from './types';

export function useReportClickReferrerCreate(
  initialArgs?: ReportClickReferrerCreateParams,
  options?: ActionOptions<
    ReportClickReferrerCreateParams,
    Awaited<ReturnType<ReportClickReferrerCreate>>
  >,
): ActionHook<ReportClickReferrerCreateParams, Awaited<ReturnType<ReportClickReferrerCreate>>> {
  const dataProvider = useDataProvider<GPDataProvider>();
  const queryClient = useQueryClient();
  const mutation = useMutation<
    Awaited<ReturnType<ReportClickReferrerCreate>>,
    Error,
    ReportClickReferrerCreateParams
  >({
    ...options,
    mutationFn: (args) =>
      queryClient.fetchQuery({
        queryKey: [
          'custom-action',
          'reportClickReferrerCreate',
          stableSerialize(args ?? initialArgs),
        ],
        queryFn: () =>
          dataProvider.reportClickReferrerCreate(
            args ?? initialArgs ?? ({} as ReportClickReferrerCreateParams),
          ),
        staleTime: 5 * 60 * 1000,
      }),
  });
  return [
    (args, callOptions) =>
      mutation.mutateAsync(
        args ?? initialArgs ?? ({} as ReportClickReferrerCreateParams),
        callOptions,
      ),
    mutation,
  ];
}
